buildCustomSelect()

let lastUrl = location.href
new MutationObserver(() => {
  const currentUrl = location.href
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl

    setTimeout(() => {
      buildCustomSelect()
    }, 100)
  }
}).observe(document, { subtree: true, childList: true })

function buildCustomSelect () {
  const x = document.querySelectorAll('.select.select__triangl')
  const l = x.length

  for (let i = 0; i < l; i++) {
    const selElmnt = x[i].getElementsByTagName('select')[0]
    if (selElmnt.nextElementSibling) return
    const ll = selElmnt.length

    const a = document.createElement('div')
    a.classList.add('select-selected')
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
    x[i].appendChild(a)

    const b = document.createElement('div')
    b.classList.add('select-items', 'select-hide')
    for (let j = 1; j < ll; j++) {
      const c = document.createElement('div')
      c.innerHTML = selElmnt.options[j].innerHTML
      c.addEventListener('click', (e) => {
        const s = e.target.parentNode.parentNode.getElementsByTagName('select')[0]
        const sl = s.length
        const h = e.target.parentNode.previousSibling
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML === e.target.innerHTML) {
            s.selectedIndex = i
            h.innerHTML = e.target.innerHTML
            const y = e.target.parentNode.getElementsByClassName('same-as-selected')
            const yl = y.length
            for (let k = 0; k < yl; k++) {
              y[k].removeAttribute('class')
            }
            e.target.classList.add('same-as-selected')
            break
          }
        }
        h.dispatchEvent(new Event('input', { bubbles: true }))
      })
      b.appendChild(c)
    }
    x[i].appendChild(b)
    a.addEventListener('click', (e) => {
      e.stopPropagation()
      Array.from(document.querySelectorAll('.facets-desktop__summary')).forEach((el) => {
        el.setAttribute('aria-expanded', 'false')
      })
      Array.from(document.querySelectorAll('.facets-desktop__disclosure-vertical')).forEach((facetDetail) => {
        facetDetail.removeAttribute('open')
      })
      Array.from(document.querySelectorAll('.mobile-facets__summary')).forEach((el) => {
        el.setAttribute('aria-expanded', 'false')
        el.closest('details').removeAttribute('open')
      })
      e.target.nextSibling.classList.toggle('select-hide')
      e.target.classList.toggle('select-arrow-active')
    })
  }
}

function closeAllSelect (elmnt) {
  const arrNo = []
  const x = document.getElementsByClassName('select-items')
  const y = document.getElementsByClassName('select-selected')
  const xl = x.length
  const yl = y.length
  for (let i = 0; i < yl; i++) {
    if (elmnt === y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove('select-arrow-active')
    }
  }
  for (let i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add('select-hide')
    }
  }
}

document.addEventListener('click', closeAllSelect)
